export const formatPrice = currentPrice => {
  return new Intl.NumberFormat('pt-br', {
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(currentPrice);
};
